(function ($) {
  $(function () {
    if ($(".testimonial-slider").length) {
      var testimonial = document.querySelectorAll(
        ".testimonial-slider .content-wrapper"
      );
      if (testimonial.length == 1) {
        $(".testimonial-slider").addClass("one-card");
      }
      initLogoSlider();

      // $(window).on("resize", initLogoSlider);

      function initLogoSlider() {
        if (testimonial.length > 1) {
          if ($(".testimonial-slider .wrapper .sliderControls").length === 0) {
            $(".testimonial-slider .wrapper").append(
              '<div class="sliderControls"></div>'
            );
          }
          if (
            $(".testimonial-slider .wrapper .sliderControls .slick-prev")
              .length === 0
          ) {
            $(".testimonial-slider .sliderControls").append(
              '<span class="slick-prev slick-arrow"></span>'
            );
          }
          if (
            $(".testimonial-slider .wrapper .sliderControls slick-next ")
              .length === 0
          ) {
            $(".testimonial-slider .sliderControls").append(
              '<span class="slick-next  slick-arrow"></span>'
            );
          }

          $(".slider").on("init", function () {
            new WOW().init();
          });
          $(".testimonial-slider").each(function () {
            if ($(this).find(".content-wrapper").length > 1) {
              $(this).find(".slider").slick({
                SlideToShow: 2,
                SlideToScroll: 1,
                centerMode: true,
                centerPadding: "300px",
                infinite: true,
                arrows: true,
                dots: true,
                appendDots: $(this).find(".sliderControls"),
                prevArrow: $(this).find(".sliderControls .slick-prev"),
                nextArrow: $(this).find(".sliderControls .slick-next"),
  
                responsive: [
                  {
                    breakpoint: 2499,
                    settings: {
                      centerPadding: "110px",
                    },
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      SlideToShow: 1,
                      centerMode: false,
                      adaptiveHeight: true,
                    },
                  },
                ],
              });
            }
          });
          // $(".testimonial-slider .content-wrapper").each(function () {
          //     var textCount = $(this).find("p").text().trim().length;
          //     if (textCount >= 208) {
          //         $(this).addClass("trim");
          //     }
          // });
        }
      }
    }
  });
  $(window).on("load", function () {
    $(".testimonial-slider").css({ opacity: "1" });
  });
})(jQuery);
